<template>
  <v-app class="pa-3">
    <v-overlay :opacity="1" :value="overlay" color="#fff">
      <v-progress-circular indeterminate size="130" :width="2" color="pink darken-1">
        <v-img width="80" src="@/assets/loader.gif" />
      </v-progress-circular>
    </v-overlay>
    <v-app-bar class="px-5" app flat>
      <a href="http://abriron.com" target="_blank">
        <v-img
          width="120"
          src="https://abriron.com/wp-content/uploads/2020/12/ironlogo.png"
        />
      </a>
      <v-spacer />
    </v-app-bar>
    <v-main>
      <v-form ref="form">
        <v-container>
          <v-card
            class="mx-auto justify-center mb-6"
            max-width="380"
            :elevation="isMobile ? 0 : 10"
            :flat="isMobile"
          >
            <v-row v-if="data.verify == 'done'" :class="{ 'mx-0': !isMobile }">
              <v-card-title class="justify-center mx-auto my-4" grey darken-3>
                {{ $t("thanksToBuy") }}
              </v-card-title>
              <v-col class="py-0" cols="12">
                <v-alert dense text class="mt-3" type="success">
                  {{ $t("paymentSuccess") }}
                </v-alert>
              </v-col>
              <v-col class="py-0 px-4" cols="12">
                <p class="mx-auto">
                  {{ $t("amount") }} : {{ $numberFormat(data.amount) }}
                  {{ data.currency }}
                </p>
                <p class="mx-auto">{{ $t("invoic-number") }} : {{ data.number }}</p>
                <p class="mx-auto">
                  {{ $t("transactionId") }} : {{ data.transaction_id }}
                </p>
              </v-col>
              <v-col class="py-0 px-4 pb-3" cols="12">
                <telegram-button
                  :url="
                    'https://abr.abriron.com/' +
                    (!data.type ? 'print/invoice/' : 'pi/') +
                    '' +
                    data.uid
                  "
                  btn-text=""
                  :has-icon="true"
                  :description="$t('invoice')"
                  class="me-4"
                />
                <whatsapp-button
                  :url="
                    'https://abr.abriron.com/' +
                    (!data.type ? 'print/invoice/' : 'pi/') +
                    '' +
                    data.uid
                  "
                  btn-text=""
                  :has-icon="true"
                />
              </v-col>
            </v-row>
            <v-row v-if="data.verify !== 'done'" :class="{ 'mx-0': !isMobile }">
              <v-col class="py-0" cols="12">
                <v-alert dense text class="mt-3" type="error">
                  {{ $t("paymentError") }}
                </v-alert>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-form>
    </v-main>
    <v-footer class="py-2" style="font-size: 12px" padless>
      <v-col class="text-center py-1" cols="12">
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-app>
</template>

<script>
import General from "../../../../Mixins/general";
import Snakbar from "../../components/general/snakbar/snakbar";
import WhatsappButton from "vue-share-buttons/src/components/WhatsAppButton";
import TelegramButton from "vue-share-buttons/src/components/TelegramButton";
export default {
  name: "PaymentVerify",
  components: { WhatsappButton, TelegramButton, Snakbar },
  mixins: [General],
  data() {
    return { overlay: false, loading: false, data: false };
  },
  beforeMount() {
    this.data = JSON.parse(this.$route.query.o_).gateway;
  },
};
</script>

<style scoped>
div.vue-tel-input-vuetify > .v-input {
  margin-inline-end: 8px !important;
}
</style>
